module.exports = __webpack_public_path__ + "static/media/logo-mobile.bc226599.svg";